import React, { Component } from 'react';

import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { BarChart, MedianBarChart } from '../../components/bar-chart/';
import styles from './chart-area.module.scss';
import * as selectors from '../../reducers';
import { humanizeNumber } from '../../helpers/formatters';
import { entityLabelMatcher } from '../../helpers/label-mapper';

class ChartArea extends Component {
  constructor() {
    super();
    this.chartMapper = this.chartMapper.bind(this);
  }

  getLegendPhrase(chartData) {
    const { activeCouncil } = this.props;
    const area = activeCouncil[chartData.area];
    return area;
  }

  renderTrend(trend) {
    if (!trend) {
      return null;
    }

    const color = '#9a8273';
    return (
      <span
        style={{
          color,
          marginRight: 10,
        }}
      >
        {trend === '−' ? 'No Trend' : `Trend ${trend}`}
      </span>
    );
  }
  isTextBarChart(data) {
    return data.max === 'High';
  }

  // not the nicest, I'm sorry.
  getAdditionalChartText(title) {
    switch (title) {
      case 'Operating Surplus Ratio': {
        return 'The state government’s target for the council is between 0 and 10 per cent.';
      }
      case 'Net Financial Liabilities': {
        return 'The state government’s target for the council is less than 60 per cent.';
      }
      case 'Asset Sustainability Ratio': {
        return 'The state government’s target for the council is greater than 90 per cent.';
      }
      default: {
        return null;
      }
    }
  }

  chartMapper(chartData, index) {
    const {
      color,
      unit,
      activeCouncil,
      comparedCouncil,
      title,
      councils,
      visible,
      trend,
      isMobile,
    } = this.props;
    switch (chartData.type) {
      case 'main':
        return (
          <BarChart
            key={index}
            data={chartData}
            color={color}
            unit={unit}
            isMobile={isMobile}
            tickIsHidden={
              activeCouncil.isBlank ||
              activeCouncil.entityType.includes('Other Entities')
            }
            visible={visible}
            isStatic={activeCouncil.entityType.includes('Other Entities')}
            title={title}
          >
            {this.renderTrend(trend)}
            {activeCouncil.entityType.includes('Other Entities')
              ? ''
              : activeCouncil.name}
          </BarChart>
        );
      case 'compared':
        return (
          <BarChart
            key={index}
            data={chartData}
            color={color}
            unit={unit}
            tickIsHidden={comparedCouncil.isBlank}
            visible={visible}
            title={title}
            isMobile={isMobile}
          >
            {this.renderTrend(trend)}

            {comparedCouncil.name}
          </BarChart>
        );
      case 'median':
        const medianCount = councils.filter(
          (council) =>
            council[chartData.area] === activeCouncil[chartData.area] &&
            !council.isBlank
        );

        // Don't show median bar if only one entity / one entity in category
        if (
          chartData.max === 'High' ||
          activeCouncil.entityType.includes('Other Entities') ||
          medianCount.length < 2
        ) {
          // No median for text bar chart or institutions
          return <div></div>;
        }

        return ['Generation capacity', 'Power stations'].indexOf(title) < 0 ? (
          <MedianBarChart
            key={index}
            data={chartData}
            color={color}
            unit={unit}
            visible={visible}
            title={title}
          >
            <div className={styles.chartLegend}>
              Median of {medianCount ? medianCount.length : 0}{' '}
              <span className={styles.chartLegendBold}>
                {entityLabelMatcher(
                  activeCouncil.entityType,
                  'plural'
                ).toLocaleLowerCase()}
              </span>
            </div>
          </MedianBarChart>
        ) : null;
      case 'text':
        const additionalText = this.getAdditionalChartText(title);
        switch (title) {
          case 'Generation capacity':
            return null;
          case 'Power stations':
            return null;
          default:
            return activeCouncil.entityType.includes('Other Entities') ? (
              <div></div>
            ) : (
              <div key={index} className={styles.chartBottomText}>
                <span>{title}</span> reported for Queensland{' '}
                {entityLabelMatcher(
                  activeCouncil.entityType,
                  'plural'
                ).toLocaleLowerCase()}{' '}
                ranged from {humanizeNumber(chartData.trueMin, unit)} to{' '}
                {humanizeNumber(chartData.max, unit)}.{' '}
                {comparedCouncil || this.isTextBarChart(chartData)
                  ? null
                  : 'Median is the middle value in the selected data range.'}
                {additionalText && additionalText}
              </div>
            );
        }
      default:
        return null;
    }
  }

  render() {
    const { data } = this.props;
    return data ? data.map((d, i) => this.chartMapper(d, i)) : null;
    // return data.map((d, i) => this.chartMapper(d, i));
    // return typeof data !== 'undefined' &&
    //   data !== null &&
    //   Object.keys(data).length !== 0
    //   ? data.map((d, i) => this.chartMapper(d, i))
    //   : null;
  }
}

const mapStateToProps = (state) => ({
  activeCouncil: selectors.getActiveEntity(state),
  councils: selectors.getEntities(state),
  comparedCouncil: selectors.getComparedEntity(state),
  isMobile: selectors.getIsMobile(state),
});

ChartArea.propTypes = {
  activeCouncil: PropTypes.object.isRequired,
  comparedCouncil: PropTypes.object,
  data: PropTypes.array.isDefined,
  color: PropTypes.string.isRequired,
  unit: PropTypes.string.isRequired,
  visible: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps, null)(ChartArea);



// WEBPACK FOOTER //
// ./src/components/data-card-row/chart-area.js